import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Pagination from '../pagination';
import { OfficeAction } from '../../store/actions';

class List extends PureComponent {
  static propTypes = {
    deleteOffice: PropTypes.func,
    getOffices: PropTypes.func,
    location: PropTypes.object,
    offices: PropTypes.object,
    permissions: PropTypes.arrayOf(PropTypes.string),
  };

  componentDidMount() {
    this.props.getOffices(
      Object.fromEntries(new URLSearchParams(this.props.location.search)),
    );
  }

  onDelete(row) {
    if (!confirm('Are you sure?')) {
      return;
    }
    this.props.deleteOffice(row.id);
  }

  onSearch(event) {
    const {
      target: { value },
    } = event;
    this.props.getOffices({ query: value });
  }

  render() {
    const {
      getOffices = () => {},
      location = {},
      offices: { data: offices = [], links = [] } = {},
      permissions = [],
    } = this.props;
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Office</h3>
              <div className="card-tools d-print-none">
                <Pagination
                  getList={getOffices}
                  links={links}
                  location={location}
                />
              </div>
              <div className="card-tools d-print-none mr-2">
                <div
                  className="input-group input-group-sm"
                  style={{ width: '150px' }}
                >
                  <input
                    className="form-control"
                    onChange={this.onSearch.bind(this)}
                    placeholder="Search"
                    type="text"
                  />
                </div>
              </div>
              {permissions?.includes?.('office.create') && (
                <div className="card-tools d-print-none mr-2">
                  <div className="input-group input-group-sm">
                    <Link
                      className="btn btn-primary btn-sm"
                      to={`${this.props.match?.path}/create`}
                    >
                      <i className="fas fa-plus-square mr-1"></i>
                      Create
                    </Link>
                  </div>
                </div>
              )}
            </div>
            <div className="card-body p-0 table-responsive">
              {offices?.length === 0 && (
                <p className="text-center my-2">No data found.</p>
              )}
              {offices?.length > 0 && (
                <table className="table table-striped text-nowrap">
                  <thead>
                    <tr>
                      {permissions?.some?.(p =>
                        ['office.delete', 'office.edit']?.includes?.(p),
                      ) && (
                        <th
                          className="d-print-none"
                          style={{ minWidth: '175px' }}
                        >
                          Action
                        </th>
                      )}
                      <th>Name</th>
                      <th>Address</th>
                      <th>Mobile Number</th>
                      <th>Logo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {offices?.map?.(row => (
                      <tr key={row.id}>
                        {permissions?.some?.(p =>
                          ['office.delete', 'office.edit']?.includes?.(p),
                        ) && (
                          <td className="d-print-none">
                            <div className="btn-group">
                              {permissions?.includes?.('office.edit') && (
                                <Link
                                  className="btn btn-info btn-sm"
                                  to={`${this.props.match?.path}/${row.id}/edit`}
                                >
                                  <i className="fas fa-edit mr-1"></i>
                                  Edit
                                </Link>
                              )}
                              {permissions?.includes?.('office.delete') && (
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => this.onDelete(row)}
                                  type="button"
                                >
                                  <i className="fas fa-trash mr-1"></i>
                                  Delete
                                </button>
                              )}
                            </div>
                          </td>
                        )}
                        <td>{row.name}</td>
                        <td>{row.address}</td>
                        <td>{row.mobile_number}</td>
                        <td>
                          {row.logo_url && (
                            <img height="30" src={row.logo_url} width="30" />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  offices: state?.office?.list,
  permissions: state?.auth?.permissions,
});

const mapDispatchToProps = dispatch => ({
  deleteOffice: id => dispatch(OfficeAction.deleteOffice(id)),
  getOffices: params => dispatch(OfficeAction.getOffices(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(List);
